import {useState} from "react";

export function useDataFormFields(){
  const [formData, setFormData] = useState({
    totalConsultasMedicasAno: '',
    numeroDeConsultasOutrosProfissionaisAno: '',
    totalConsultasFisioterapiaAno: '',
    totalConsultasPsicologiaAno: '',
    totalConsultasNutricionistaAno: '',
    totalConsultasFonoaudiologiaAno: '',
    totalConsultasOutrosNaoMedicosAno: '',
    totalExamesAmbulatoriaisAno: '',
    totalInternacoesHospitalaresAno: '',
    totalProcedimentosAmbulatoriaisAno: '',
    totalInternacoesClinicasAno: '',
    totalInternacoesCirurgicasAno: '',
    totalInternacoesPartoAno: '',
    totalInternacoesUTIAno: '',
    totalNascidosVivosAnoAnterior: ''
  });


  const usageField = [
    {
      id: "totalConsultasMedicasAno",
      label: "Quantidade total de consultas médicas/ano",
      value: formData.totalConsultasMedicasAno,
      hint: () => (
            <ol className="space-y-2">
              <li>1. Analise o total de consultas médicas ambulatoriais dos últimos 24 ou 36 meses de sua Operadora.</li>
              <li>2. Calcule o número anual médio de consultas.</li>
              <li>3. Informe o número de consultas obtido.</li>
            </ol>
        )
    },
    {
      id: "totalExamesAmbulatoriaisAno",
      label: "Quantidade total de exames ambulatoriais/ano",
      value: formData.totalExamesAmbulatoriaisAno,
      hint:  () => (
        <ol className="space-y-2">
          <li>1. Analise o total de exames ambulatoriais dos últimos 24 ou 36 meses de sua Operadora.</li>
          <li>2. Calcule o número anual médio de exames ambulatoriais.</li>
          <li>3. Informe o número de exames obtido.</li>
        </ol>
      )
    },
    {
      id: "numeroDeConsultasOutrosProfissionaisAno",
      label: "Quantidade total de consultas com outros profissionais/ano",
      value: formData.numeroDeConsultasOutrosProfissionaisAno,
      hint:  () => (
        <ol className="space-y-2">
          <li>1. Analise o total de sessões/consultas ambulatoriais de fisioterapia, psicologia, nutricão,
            fonoaudiologia e outros profissionais não médicos de sua Operadora últimos 24 ou 36 meses. Não incluir cirurgiões dentista.</li>
          <li>2. Calcule o número anual médio de sessões/consultas ambulatoriais de todos os profissionais não médicos</li>
          <li>3. Informe o número de sessões/consultas ambulatoriais obtido.</li>
        </ol>
      ),
    },
    {
      id: "totalConsultasFisioterapiaAno",
      label: "Quantidade total de sessões/consultas ambulatoriais de fisioterapia/ano",
      value: formData.totalConsultasFisioterapiaAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de sessões/consultas ambulatoriais de fisioterapia de sua Operadora últimos 24 ou 36 meses.</li>
          <li>2. Calcule o número anual médio de sessões/consultas ambulatoriais.</li>
          <li>3. Informe o número de sessões/consultas ambulatoriais obtido.</li>
        </ol>
      ),
    },
    {
      id: "totalConsultasPsicologiaAno",
      label: "Quantidade total de sessões/consultas ambulatoriais de psicologia/ano",
      value: formData.totalConsultasPsicologiaAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de sessões/consultas ambulatoriais de psicologia de sua Operadora nos últimos 24 ou 36 meses.</li>
          <li>2. Calcule o número anual médio de sessões/consultas ambulatoriais.</li>
          <li>3. Informe o número de sessões/consultas ambulatoriais obtido.</li>
        </ol>
      )
    },
    {
      id: "totalConsultasNutricionistaAno",
      label: "Quantidade total de sessões/consultas ambulatoriais de nutricionista/ano",
      value: formData.totalConsultasNutricionistaAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de sessões/consultas ambulatoriais de nutricionista de sua Operadora nos últimos 24 ou 36 meses.</li>
          <li>2. Calcule o número anual médio de sessões/consultas ambulatoriais.</li>
          <li>3. Informe o número de sessões/consultas ambulatoriais obtido.</li>
        </ol>
      )
    },
    {
      id: "totalConsultasFonoaudiologiaAno",
      label: "Quantidade total de sessões/consultas ambulatoriais de fonoaudiologia/ano",
      value: formData.totalConsultasFonoaudiologiaAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de sessões/consultas ambulatoriais de fonoaudiologia de sua Operadora nos últimos 24 ou 36 meses.</li>
          <li>2. Calcule o número anual médio de sessões/consultas ambulatoriais.</li>
          <li>3. Informe o número de sessões/consultas ambulatoriais obtido.</li>
        </ol>
      )
    },
    {
      id: "totalConsultasOutrosNaoMedicosAno",
      label: "Quantidade total de sessões/consultas ambulatoriais de outros profissionais não médicos/ano",
      value: formData.totalConsultasOutrosNaoMedicosAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de sessões/consultas ambulatoriais de outros profissionais, como psicopedagogos, educador físico, etc., que atuem com consultas/sessões, de sua Operadora nos últimos 24 ou 36 meses.</li>
          <li>2. Calcule o número anual médio de sessões/consultas ambulatoriais de todos os profissionais deste grupo.</li>
          <li>3. Informe o número de sessões/consultas ambulatoriais obtido.</li>
        </ol>
      )
    },
    {
      id: "totalProcedimentosAmbulatoriaisAno",
      label: "Quantidade total de procedimentos ambulatoriais/ano",
      value: formData.totalProcedimentosAmbulatoriaisAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de procedimentos ambulatoriais de sua Operadora nos últimos 24 ou 36 meses.</li>
          <li>2. Calcule o número anual médio de procedimentos ambulatoriais.</li>
          <li>3. Informe o número de procedimentos ambulatoriais obtido.</li>
        </ol>
      )
    },
    {
      id: "totalInternacoesHospitalaresAno",
      label: "Quantidade total de internações hospitalares/ano",
      value: formData.totalInternacoesHospitalaresAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de internações hospitalares de sua Operadora nos últimos 24 ou 36 meses. Inclui internações em hospital dia.</li>
          <li>2. Calcule o número anual médio de internações hospitalares.</li>
          <li>3. Informe o número de internações hospitalares obtido.</li>
        </ol>
      )
    },
    {
      id: "totalInternacoesClinicasAno",
      label: "Quantidade total de internações clínicas/ano",
      value: formData.totalInternacoesClinicasAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de internações clínicas hospitalares de sua Operadora nos últimos 24 ou 36 meses.</li>
          <li>2. Calcule o número anual médio de internações clínicas hospitalares.</li>
          <li>3. Informe o número de internações clínicas hospitalares obtido.</li>
        </ol>
      )
    },
    {
      id: "totalInternacoesCirurgicasAno",
      label: "Quantidade total de internações cirúrgicas/ano",
      value: formData.totalInternacoesCirurgicasAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de internações cirúrgicas hospitalares de sua Operadora nos últimos 24 ou 36 meses. Inclui internações em hospital dia.</li>
          <li>2. Calcule o número anual médio de internações cirúrgicas hospitalares.</li>
          <li>3. Informe o número de internações cirúrgicas hospitalares obtido.</li>
        </ol>
      )
    },
    {
      id: "totalInternacoesUTIAno",
      label: "Quantidade total de internações em UTI/ano",
      value: formData.totalInternacoesUTIAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de internações hospitalares em Unidades de Terapia Intensiva de sua Operadora nos últimos 24 ou 36 meses. Inclui internações em UTI, CTI, UTI intermediária, UTI Pediátrica e UTI Neonatal.</li>
          <li>2. Calcule o número anual médio de internações hospitalares em UTI.</li>
          <li>3. Informe o número de internações hospitalares em UTI obtido.</li>
        </ol>
      )
    },
    {
      id: "totalInternacoesPartoAno",
      label: "Nº de Partos no ano anterior",
      value: formData.totalInternacoesPartoAno,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Analise o total de partos de sua Operadora considerando o último ano (janeiro a dezembro). Considerar partos via vaginal e cesáreo. Inclui os códigos TUSS: 3.13.09.05-4, 3.13.09.12-7, 3.13.09.13-5, 3.13.09.15-1, 3.13.09.03-8, 3.13.09.10-0, 3.13.09.20-8 ou outro código próprio adotado na Operadora.</li>
          <li>2. Informe o número de partos obtido.</li>
        </ol>
      )
    },
    {
      id: "totalNascidosVivosAnoAnterior",
      label: "Nº de nascidos vivos no ano anterior",
      value: formData.totalNascidosVivosAnoAnterior,
      hint: () => (
        <ol className="space-y-2">
          <li>1. Utilize o valor obtido no campo Nº de partos no ano anterior.</li>
          <li>2. Informe o número de nascidos vivos obtido.</li>
        </ol>
      )
    }
  ]

  return [formData, setFormData, usageField]
}